__turbopack_context__.v({
  "chevron": "time-picker-module-scss-module__02UNFG__chevron",
  "chevronOpen": "time-picker-module-scss-module__02UNFG__chevronOpen",
  "clockIcon": "time-picker-module-scss-module__02UNFG__clockIcon",
  "clockIconOpen": "time-picker-module-scss-module__02UNFG__clockIconOpen",
  "dropdown": "time-picker-module-scss-module__02UNFG__dropdown",
  "label": "time-picker-module-scss-module__02UNFG__label",
  "option": "time-picker-module-scss-module__02UNFG__option",
  "placeholder": "time-picker-module-scss-module__02UNFG__placeholder",
  "root": "time-picker-module-scss-module__02UNFG__root",
  "selectContainer": "time-picker-module-scss-module__02UNFG__selectContainer",
  "selectField": "time-picker-module-scss-module__02UNFG__selectField",
  "selectText": "time-picker-module-scss-module__02UNFG__selectText",
  "selected": "time-picker-module-scss-module__02UNFG__selected",
});
